import gql from 'graphql-tag';
const UPDATE_USER = gql`
  mutation updateUser(
    $isAuthenticated: Boolean!
    $id: ID
    $username: String!
    $email: String!
    $cognitoUserId: String!
    $avatar: String
    $features: [String!]!
    $notifications: [Object!]!
    $defaultRole: JSON!
    $role: JSON!
    $roles: [JSON!]
    $isAdmin: Boolean
    $isPreviewOrg: Boolean
    $permission: JSON!
    $msaStatus: MSAVersion
    $ssoToken: String
    $articles: Boolean
    $campaignTableDisplayColumns: [String!]
    $timezone: String
  ) {
    updateUser(
      isAuthenticated: $isAuthenticated
      id: $id
      username: $username
      email: $email
      cognitoUserId: $cognitoUserId
      avatar: $avatar
      features: $features
      notifications: $notifications
      defaultRole: $defaultRole
      role: $role
      roles: $roles
      isAdmin: $isAdmin
      isPreviewOrg: $isPreviewOrg
      permission: $permission
      msaStatus: $msaStatus
      ssoToken: $ssoToken
      articles: $articles
      campaignTableDisplayColumns: $campaignTableDisplayColumns
      timezone: $timezone
    ) @client
  }
`;

export default UPDATE_USER;
